import React from 'react';
import { CardButton, CardButtons, CardCollection, CardContainer, CardCreator, CardImage, CardMeta, CardPrice, CardTitle, CreatorImage, CreatorInfo, CreatorLabel, CreatorName } from './styled';
import { ReactComponent as ForkIcon } from '../../../../assets/svg/git-fork.svg'
import { ReactComponent as AlertIcon } from '../../../../assets/svg/alert.svg'
import { ReactComponent as VerifiedIcon } from '../../../../assets/svg/verified.svg'
import { useGetSaleTokenItem } from '../../../../hooks/useNFTMarketPlace';
import useGetNFTCollection from '../../data/useGetNFTCollection';
import INFTCollections from '../../models/INFTCollections';
import NFTPriceSymbol from '../../components/NFTPriceSymbol';


const NFTCard = (props: any) => {

    const saleTokenItem = useGetSaleTokenItem(props.saleToken)
    const collection: INFTCollections = useGetNFTCollection(props.tokenContract);

    return (
        <CardContainer>
            <CardImage>
                {props.children}
            </CardImage>
            <CardTitle>
                {props.title}
            </CardTitle>
            {collection && collection.tokenAddress != "0x0000000004bFeF9b1A67aA4E15943824996c9761" && <CardCollection title='Verified Collection'>
                {collection.forkProject && (
                    <ForkIcon width="0.9rem" height="0.9rem" className="form-icon" title="Forked Collection" />
                )}
                {collection.oldProject && (
                    <AlertIcon width="0.9rem" height="0.9rem" className="form-icon" title="Old Project, You need to migrate new version" />
                )}
                <VerifiedIcon width="1rem" />
                {collection.name}
            </CardCollection>}
            <CardMeta>
                <CardCreator>
                    <CreatorImage />
                    <CreatorInfo>
                        <CreatorLabel>{collection ? "Seller" : "Creator"}</CreatorLabel>
                        <CreatorName>{props.seller}</CreatorName>
                    </CreatorInfo>
                </CardCreator>
                <CardPrice>
                    <span>Price</span>
                    <div>
                        {props.price} <NFTPriceSymbol symbol={saleTokenItem.symbol} image={saleTokenItem.image} />
                    </div>
                </CardPrice>
            </CardMeta>
            <CardButtons>
                <CardButton>Buy Now!</CardButton>
            </CardButtons>
        </CardContainer>
    )
}
export default NFTCard;